import useOtpActions  from './_actions';

export const useOtp = () => {
    const {
        getOtpbyPhoneNumber,
        refreshDialogState
    } = useOtpActions();

    return {
        //state

        //actions
        getOtpbyPhoneNumber,
        refreshDialogState
    }
}

export { default as otpReducer } from './_reducers';
